module.exports = __webpack_public_path__ + "img/no_goods.20f2d3e0.png";